import { Box, Typography } from '@mui/material';

const DetailedProductNotFound: React.FC = () => (
  <Box>
    <Typography variant="h5">Product not found</Typography>
  </Box>
);

export default DetailedProductNotFound;
